import { render } from "./ImportedItemsIndex.vue?vue&type=template&id=0083d9b8&scoped=true"
import script from "./ImportedItemsIndex.vue?vue&type=script&lang=js"
export * from "./ImportedItemsIndex.vue?vue&type=script&lang=js"

import "./ImportedItemsIndex.vue?vue&type=style&index=0&id=0083d9b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0083d9b8"]])

export default __exports__